var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.class_cont},[_c('BPIdLayout',{attrs:{"layout":_vm.layout,"objects":_vm.objects},scopedSlots:_vm._u([{key:"element",fn:function(ref){
var data = ref.data;
return [_c('Chart',{class:_vm.class_chart,attrs:{"title":data.title,"chardata":data.chartdata,"type":data.type}})]}}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }